import React from 'react';
import {
  SearchChatsInput,
  SearchChatsZone,
  OrderChatWrapper,
  SearchButton,
  Divider
} from '../../styled';
import { IoFilterSharp, IoSearch } from 'react-icons/io5';
import { FiltersChat } from '../Filters';
import { DropdownToggle } from 'reactstrap';
import { TbArrowsTransferUp } from 'react-icons/tb';
import { SorterChat } from '../Filters/Sort';
import { useSelector } from 'react-redux';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';

export const SearchChat = ({
  setSearch,
  search = '',
  handlerFilter,
  tags,
  handlerSort
}) => {
  const [openDropDown, setOpenDropDown] = React.useState(false);
  const [openDropDownSort, setOpenDropDownSort] = React.useState(false);

  const toggle = () => setOpenDropDown((prevState) => !prevState);
  const toggleSort = () => setOpenDropDownSort((prevState) => !prevState);

  const { primary_color } = useSelector((state) => state.systemConfiguration);

  const { filters, sort } = useQueueContentChatContext();

  const BallonCheck = () => {
    return (
      <div
        style={{
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          backgroundColor: primary_color
        }}
      />
    );
  };

  const hasSort = Object.values(sort).some((sort) => sort !== false);

  const hasFilter = Object.values(filters).some(
    (filter) => filter.length > 0 && filter !== false
  );

  const outIconStyleFormatter = {
    border: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
    position: 'relative'
  };

  return (
    <>
      <SearchChatsZone>
        <SearchChatsInput
          placeholder="Buscar conversas..."
          withData={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />

        <SearchButton bgColor={primary_color}>
          <IoSearch size={20} color="#fff" />
        </SearchButton>

        <Divider />

        <OrderChatWrapper>
          <SorterChat
            openDropDown={openDropDownSort}
            toggle={toggleSort}
            handlerSort={handlerSort}
          >
            <DropdownToggle outline={true} style={outIconStyleFormatter}>
              <div
                style={{
                  width: '20px',
                  height: '30px',
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'end',
                  flexDirection: 'column'
                }}
              >
                {hasSort && <BallonCheck />}
                <TbArrowsTransferUp
                  id="filterChatSort"
                  size={20}
                  color="rgb(113 113 122)"
                />
              </div>
            </DropdownToggle>
          </SorterChat>

          <FiltersChat
            openDropDown={openDropDown}
            toggle={toggle}
            handlerFilter={handlerFilter}
            tags={tags}
          >
            <DropdownToggle outline={true} style={outIconStyleFormatter}>
              <div
                style={{
                  width: '20px',
                  height: '30px',
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'end',
                  flexDirection: 'column'
                }}
              >
                {hasFilter && <BallonCheck />}
                <IoFilterSharp
                  id="filterChat"
                  size={20}
                  color="rgb(113 113 122)"
                />
              </div>
            </DropdownToggle>
          </FiltersChat>
        </OrderChatWrapper>
      </SearchChatsZone>
    </>
  );
};
